var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 5.33366C21.3335 6.80642 17.7518 8.00033 13.3335 8.00033C8.91522 8.00033 5.3335 6.80642 5.3335 5.33366M21.3335 5.33366C21.3335 3.8609 17.7518 2.66699 13.3335 2.66699C8.91522 2.66699 5.3335 3.8609 5.3335 5.33366M21.3335 5.33366V10.667M5.3335 5.33366V10.667C5.3335 12.1398 8.91522 13.3337 13.3335 13.3337C17.7518 13.3337 21.3335 12.1398 21.3335 10.667M26.6668 13.1819C26.6668 14.6547 23.0851 15.8486 18.6668 15.8486C14.2486 15.8486 10.6668 14.6547 10.6668 13.1819V18.5153M26.6668 13.1819C26.6668 12.0208 24.4407 11.0331 21.3335 10.667M26.6668 13.1819V18.5153C26.6668 19.9881 23.0851 21.182 18.6668 21.182C14.2486 21.182 10.6668 19.9881 10.6668 18.5153M5.3335 21.0302C5.3335 22.503 8.91522 23.6969 13.3335 23.6969C17.7518 23.6969 21.3335 22.503 21.3335 21.0302V26.3636C21.3335 27.8364 17.7518 29.0303 13.3335 29.0303C8.91522 29.0303 5.3335 27.8364 5.3335 26.3636V21.0302ZM5.3335 21.0302C5.3335 19.8691 7.55965 18.8814 10.6668 18.5153",
    stroke: "#7F56D9",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.6f9ffdf60ae14a9cc52b6423aba1c818.svg";
export { ForwardRef as ReactComponent };